export default function ({ redirect, $auth, route }) {
    if (!$auth.loggedIn) {
        return redirect({
            path: "/base/auth/login",
            query: { redirect: route.fullPath }
        })
    } else if (![1, 2].includes($auth.user.role)) {
        return redirect('/base/auth/login')
    }
}
